import styles from './DepartmentItem.module.scss';

const DepartmentItem = ({ value }) => (
  <span className={styles.item}>
    {value.label} ({value.quantity})
  </span>
);

export default DepartmentItem;
